import { WHATSAPP_URL } from "@/lib/site";

/**
 * Push a custom dataLayer event when a WhatsApp CTA is clicked.
 * GTM (and Google Ads via GTM) can then listen to `whatsapp_click`
 * to fire conversions / pixel events.
 */
export function trackWhatsAppClick(source = "generic") {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "whatsapp_click",
      cta_source: source,
      destination_url: WHATSAPP_URL,
    });
  } catch (_) {
    /* no-op */
  }
}
